export default __webpack_public_path__ + "static/media/ic_Dashboard.b0dc18ea.svg";